import { observer, inject } from "mobx-react";
import { useState, useEffect } from "react";
import LoadingContainer from "../layouts/LoadingContainer";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";
import { Button, Modal, Text, TextInput } from "../UI";
import { DatePicker, LocalizationProvider } from "@material-ui/pickers";
import DateFnsUtils from "@material-ui/pickers/adapter/date-fns";
import calendarImg from "../assets/img/calendar.svg";
import {
  Box,
  BoxHeader,
  InnerBox,
  SaveSuccess,
  ScrollDiv,
} from "../components/Common";
import { useInput, inputsHasError } from "../utils/hooks";
import { isNotEmpty, withError } from "../validation";
import addImg from "../assets/img/add-circle.svg";
import { he } from "date-fns/locale";
import { format } from "date-fns";
import NewDefect from "../components/NewDefect";
import { ClipLoader } from "react-spinners";
import MessageNotification, {
  useMessageNotification,
  MessageType,
} from "../components/MessageNotification";

const NewRepairPage = ({ userStore, tenantsStore, repairPagesStore }) => {
  const { t } = useTranslation("applies");
  const theme = useTheme();
  const navigate = useNavigate();


  const APPCODE = "Bdk";

  const mustPic = userStore.applicationAttributes[APPCODE]?.Bdk_MustPic === "Y"

  const location = useLocation();

  const [department, setDepartment] = useState(location?.state?.department);
  const [newRepairPage, setNewRepairPage] = useState({
    APPLICANTNAME: userStore.userDetails.NAME,
    SITENUM:
      tenantsStore.selectedContract?.SITENUM ||
      tenantsStore.selectedSiteSpace?.SITENUM ||
      location?.state?.SITENUM,
    BUILDINGNUM:
      tenantsStore.selectedContract?.BUILDINGNUM ||
      tenantsStore.selectedSiteSpace?.BUILDINGNUM ||
      location?.state?.BUILDINGNUM,
    SPACENUM:
      tenantsStore.selectedContract?.SPACENUM ||
      tenantsStore.selectedSiteSpace?.SPACENUM ||
      location?.state?.SPACENUM,
    SPACENAME:
      tenantsStore.selectedContract?.SPACENAME ||
      tenantsStore.selectedSiteSpace?.SPACENAME ||
      location?.state?.SPACENAME,
    CURDATE: new Date(),
  });
  const [, setError] = useState("");
  const { messageNotification, setMessageNotification } =
    useMessageNotification();
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [defectList, setDefectList] = useState([{ KLINE: 1, index: 1 }]);
  const [doValidation, setDoValidation] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [isSaving, setSaving] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  useEffect(() => {
    setDepartment(location?.state?.department);
  }, [location]);

  const handleDateChange = (date) => {
    var localDate = new Date(
      date.getTime() - date.getTimezoneOffset() * 60 * 1000
    );

    setNewRepairPage({ ...newRepairPage, CURDATE: localDate });
  };

  const handleChange = (prop) => (event) => {
    setNewRepairPage({ ...newRepairPage, [prop]: event.target.value });
  };

  const handleDateClick = (event) => {
    setOpen((open) => !open);
    setAnchorEl(event.currentTarget);
  };
  const handleImgDateClick = (ref) => {
    setOpen((open) => !open);
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const data = {
        MAINCUST: tenantsStore.selectedSiteSpace.CUST,
        CUST: tenantsStore.selectedSiteSpace.CUST,
        MAINENV: tenantsStore.selectedSiteSpace.DNAME,
        DNAME: tenantsStore.selectedContract?.DNAME,
        ENV: tenantsStore.selectedContract?.DNAME,
      };
      await repairPagesStore.getDomains(data);
      await repairPagesStore.getLocations(data);
      await repairPagesStore.getSiteAreas(data);
      setLoading(false);
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDefectChange = (defect) => {
    const newDefects = [...defectList];
    setDoValidation(false)
    const defectIndex = newDefects.findIndex((d) => {
      return defect.KLINE === d.KLINE;
    });

    newDefects[defectIndex] = defect;
    const defectsDeepCopy = JSON.parse(JSON.stringify(newDefects));

    setDefectList([...defectsDeepCopy]);
  };

  const validateDefecs = (newDiaryData) => {
    if (
      !newDiaryData.ZCOB_DEFECTSLIST_SUBFORM ||
      newDiaryData.ZCOB_DEFECTSLIST_SUBFORM.length === 0
    ) {
      setError(t("empty_defect_list"));
      setMessageNotification({
        text: t("empty_defect_list"),
        show: true,
        type: MessageType.ERROR,
      });
      return false;
    }
    const hasEmpty = newDiaryData.ZCOB_DEFECTSLIST_SUBFORM.some((p) => {
      return (
        p?.REMOVE !== true &&
        (!p?.DEFECTDES ||
          !p?.SITEAREADES ||
          !p?.LOCATIONDES ||
          !p?.CHKPERIODTYPECODE || (!p?.EXTFILENAME && mustPic))
      );
    });

    return !hasEmpty;
  };

  const handleAddApply = async () => {
    const repairData = {
      ...newRepairPage,

      ZCOB_DEFECTSLIST_SUBFORM: defectList
        .filter((defect) => defect.REMOVE !== true)
        .map((d) => {
          delete d.index;
          delete d.APPROVE;

          return d;
        }),
    };

    const body = {
      MAINCUST: tenantsStore.selectedSiteSpace.CUST,
      CUST: tenantsStore.selectedSiteSpace.CUST,
      MAINENV: tenantsStore.selectedSiteSpace.DNAME,
      CONTNAME: tenantsStore.selectedContract?.CONTNAME,
      SPACENAME:
        tenantsStore.selectedContract?.SPACENAME ||
        tenantsStore.selectedSiteSpace?.SPACENAME ||
        location?.state?.SPACENAME,
      CONT: tenantsStore.selectedContract?.CONT,
      DNAME: tenantsStore.selectedContract?.DNAME,
      ENV: tenantsStore.selectedContract?.DNAME,
    };
    const defectValid = validateDefecs(repairData);
    setDoValidation(true);
    if (!inputsHasError(date, applier) && defectValid) {
      setSaving(true);
      const repairPage = await repairPagesStore.addRepairPage({
        ...body,
        data: repairData,
      });

      if (repairPagesStore.error) {
        setError(repairPagesStore.error);
        setMessageNotification({
          text: t(repairPagesStore.error),
          show: true,
          type: MessageType.ERROR,
        });
      } else {
        const initstat = repairPagesStore.statuses?.find(
          (s) => s.INITPORTALFLAG === "Y"
        )?.STATDES;
        if (!!initstat)
          await repairPagesStore.updateRepairPage({
            ...body,
            REPAIRNAME: repairPage?.REPAIRNAME,
            data: { STATDES: initstat },
          });
        setShowSuccessModal(true);
      }

      setSaving(false);
    }
  };

  const addNewDefect = () => {
    const kline =
      defectList.filter((d) => d.REMOVE !== true).length > 0
        ? Math.max(
          ...defectList.filter((d) => d.REMOVE !== true).map((d) => d.KLINE)
        ) + 1
        : 1;

    setDefectList((arr) => [...arr, { KLINE: kline, index: arr.length + 1 }]);
  };

  const isNotEmptyWithError = withError(
    isNotEmpty,
    t("text_field_empty_error")
  );

  const applier = useInput({
    validation: [isNotEmptyWithError],
    placeholder: t("applier_placeholder"),
    value: newRepairPage?.APPLICANTNAME || "",
  });

  const date = useInput({
    validation: [isNotEmptyWithError],
    placeholder: t("date_placeholder"),
    value: format(
      newRepairPage?.CURDATE !== undefined
        ? new Date(newRepairPage.CURDATE)
        : new Date(),
      "dd/MM/yyyy"
    ),
  });

  return (
    <>
      <LoadingContainer isLoading={isLoading}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            margin: 24,
          }}
        >
          <Box flexBasis={100} style={{ width: "100%" }}>
            <InnerBox style={{ padding: 0, borderRadius: 18 }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <BoxHeader>
                  <Text.BM
                    color={theme.color.navy}
                    style={{
                      textAlign: "start",
                      padding: 20,
                      paddingBottom: 0,
                    }}
                  >
                    {t("new_apply", { type: department })}
                  </Text.BM>
                </BoxHeader>
                <div style={{ width: "100%", paddingInlineEnd: 10 }}>
                  <ScrollDiv
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 12,
                      marginTop: 20,
                      alignItems: "flex-start",
                      justifyContent: "flex-start",
                      flex: 1,
                      minHeight: "55vh",
                      maxHeight: "55vh",
                      flexBasis: "100%",
                      padding: 20,
                      borderColor: theme.color.gray30,
                    }}
                  >
                    <BoxHeader
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: 20,
                        width: "100%",
                        padding: 0,
                        paddingBottom: 20,
                      }}
                    >
                      <div style={{ width: "auto" }}>
                        <LocalizationProvider
                          dateAdapter={DateFnsUtils}
                          locale={he}
                        >
                          <DatePicker
                            closeOnSelect={true}
                            mask="__/__/__"
                            inputFormat="dd/MM/yy"
                            value={selectedDate}
                            onChange={(date) => {
                              setSelectedDate(date);
                              handleDateChange(date);
                              setOpen(false);
                            }}
                            onClose={() => setOpen(false)}
                            open={open}
                            PopperProps={{
                              placement: "bottom-end",
                              positionFixed: true,
                              anchorEl: anchorEl,
                            }}
                            renderInput={({ inputRef, inputProps }) => (
                              <div
                                style={{
                                  flex: 1,
                                }}
                              >
                                <TextInput
                                  refProp={inputRef}
                                  divStyle={{
                                    display: "flex",
                                    padding: "10px 0",
                                    justifyContent: "flex-end",
                                    alignItems: "center",
                                    maxWidth: 186,
                                    height: 50,
                                  }}
                                  {...date}
                                  variant="outlined"
                                  label={t("apply_date")}
                                  onClick={handleDateClick}
                                  onEndImgClick={() => handleImgDateClick()}
                                  endImg={calendarImg}
                                  valid={!date.error}
                                  helperText={date.helperText}
                                ></TextInput>
                              </div>
                            )}
                          />
                        </LocalizationProvider>
                      </div>
                      <div style={{ width: "auto" }}>
                        <TextInput
                          divStyle={{
                            display: "flex",
                            padding: "10px 0",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            gap: 12,
                            alignSelf: "stretch",
                            maxWidth: 186,
                            height: 50,
                          }}
                          {...applier}
                          variant="outlined"
                          onBlur={handleChange("APPLICANTNAME")}
                          onChange={handleChange("APPLICANTNAME")}
                          label={t("applier")}
                          valid={!applier.error}
                          helperText={applier.helperText}
                        ></TextInput>
                      </div>
                    </BoxHeader>
                    <Text.BM color={theme.color.navy}>
                      {t("defect_list")}
                    </Text.BM>
                    <div style={{ width: "100%" }}>
                      {defectList?.map((defect, index) => (
                        <div key={index}>
                          {defect.REMOVE !== true && (
                            <BoxHeader key={index}>
                              <NewDefect
                                validate={doValidation}
                                defect={defect}
                                handleDefectChange={handleDefectChange}
                              />
                            </BoxHeader>
                          )}
                        </div>
                      ))}
                    </div>
                    <BoxHeader
                      style={{
                        borderColor: "transparent",
                        paddingTop: 0,
                        width: "auto",
                      }}
                    >
                      <Button
                        onClick={addNewDefect}
                        style={{
                          backgroundColor: theme.color.white,
                          padding: "10px 14px",
                          border: `1px solid ${theme.color.primary}`,
                          color: theme.color.primary,
                          height: 40,
                          width: "auto",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "start",
                            alignItems: "center",
                          }}
                        >
                          <div
                            style={{
                              mask: `url(${addImg}) no-repeat center / contain`,
                              backgroundColor: theme.color.primary,
                              width: 20,
                              height: 20,
                              marginInlineEnd: 12,
                            }}
                          ></div>
                          {t("add_defect")}
                        </div>
                      </Button>
                    </BoxHeader>
                  </ScrollDiv>
                </div>
              </div>
              <div
                style={{
                  margin: "auto",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: 10,
                  flexDirection: "column",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 16,
                    padding: 10,
                    marginTop: 0,
                  }}
                >
                  <Button
                    style={{ width: 181 }}
                    onClick={handleAddApply}
                    disabled={isSaving}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 10,
                      }}
                    >
                      {isSaving && (
                        <ClipLoader color={theme.color.white} size={20} />
                      )}
                      {t("send_apply")}
                    </div>
                  </Button>
                  <Button
                    onClick={() =>
                      location?.state?.bedek === true
                        ? navigate("/bedek/applies")
                        : navigate("/tenant/applies")
                    }
                    style={{
                      width: 181,
                      backgroundColor: theme.color.white,
                      border: `1px solid ${theme.color.primary}`,
                      color: theme.color.primary,
                      marginTop: 0,
                    }}
                  >
                    {t("cancel_apply")}
                  </Button>
                </div>
              </div>
            </InnerBox>
          </Box>
        </div>
      </LoadingContainer>
      {showSuccessModal && (
        <Modal
          onClose={() => {
            setShowSuccessModal(false);
            location?.state?.bedek === true
              ? navigate("/bedek/applies")
              : navigate("/tenant/applies");
          }}
        >
          <SaveSuccess
            onButtonClick={() =>
              location?.state?.bedek === true
                ? navigate("/bedek/applies")
                : navigate("/tenant/applies")
            }
            buttonLabel={t("applay_save_successs_button")}
            textLabel={t("applay_save_successs_text")}
          />
        </Modal>
      )}
      {messageNotification?.show && (
        <MessageNotification
          type={MessageType.ERROR}
          text={messageNotification?.text}
          onClose={() =>
            setMessageNotification({
              show: false,
            })
          }
        />
      )}
    </>
  );
};

export default inject(
  "userStore",
  "tenantsStore",
  "repairPagesStore"
)(observer(NewRepairPage));
